import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchCustomers, fetchVectorsAction} from "../../../../../actions";
import {
    bbDangerousStringToDate,
    bbFormattedDateString,
    bbIsVectorPotentiallyBreaching, bbSortIpCompare
} from "../../../../../util/bbHelpers";
import BBDataTable from "../../../../../components/customBreachBits/tables/BBDataTable";
import {Chip} from "@material-ui/core";
import {renderCellExpand} from "../../../../../components/customBreachBits/tables/DataGridRenderCellExpand";
// import Tooltip from "@material-ui/core/Tooltip";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";

const TableAllCustomersVectors = (props) => {

    const {customers,  loadingCustomers, loadingVectors, loadingVectorsError} = useSelector(({customer}) => customer);
    // const {authUser} = useSelector(({auth}) => auth);
    const dispatch = useDispatch();

    const customersArr = customers && Object.values(customers);

    const numVectors = customers && customersArr.filter((customer)=> customer.vectors).length;

    const customerHasVectors = customers ? customersArr.filter((customer)=> customer.vectors && !!Object.keys(customer.vectors).length) : null;

    const vectors= customers && customersArr.filter((customer)=> customer.vectors && !!Object.keys(customer.vectors).length)
        .map((customer)=>customer.vectors);

    const addCustomerIds = customers && customerHasVectors.map((customer)=>{
        const returnObj = Object.values(customer.vectors).map((vector)=>{
            return {
                ...vector,
                customerId: customer.CustomerId
            }
        })
        return returnObj
    })


    //puts all campiagn data objects into a single array
    // let vectorsOneLevel = [];
    // vectors && vectors.forEach((vectorObj)=>{
    //     Object.values(vectorObj).forEach((vector)=>{
    //         vectorsOneLevel.push(vector)
    //     })
    // })

    //try the above thing but with the arrays that have customerIds

    let vectorsOneLevel = [];
    vectors && addCustomerIds.forEach((vectorObj)=>{
        Object.values(vectorObj).forEach((vector)=>{
            vectorsOneLevel.push(vector)
        })
    })

    // customers && console.log("vectors",vectors, "indvidual vectors", vectorsOneLevel)

    const getLastAttackDate = (vector) => {
        const Attacks  = vector.Attacks
        const attackDates = []
        if (Attacks && Object.keys(Attacks).length > 0) {
            for (const attack in Attacks) {
                attackDates.push(bbDangerousStringToDate(Attacks[attack]["Attack DateTime"]));
            }
                attackDates.sort((a, b) => b - a);

                const mostRecent = attackDates[0];
                return bbFormattedDateString(mostRecent, "short");
        } else {
            return "N/A"
        }

    }

    const tableData = customers && vectorsOneLevel.map((vector, index)=>{
        return{
            ...vector,
            name: vector.Capability && vector.Capability.Name,
            numOfAttacks: vector["Attack Totals"]["attacks"],
            ["Identified DateTime"]: bbFormattedDateString(vector["Identified DateTime"], "short"),
            id: vector.Id,
            likelyToCauseBreach: bbIsVectorPotentiallyBreaching(vector),
            statusId: vector.Status.Id,
            statusName: vector.Status.Name.slice(8) !== "Ongoing" ? vector.Status.Name.slice(14)
                : vector.Status.Name.slice(8),
            domain: vector.Fqdn ? vector.Fqdn : "N/A",
            targetDetailsIp: vector["Target Details"].IpAddress,
            targetDetailsStatus: vector["Target Details"].IsActive,
            customerName: customers[vector.customerId] ? customers[vector.customerId].CustomerName : null,
            lastAttackDate: getLastAttackDate(vector),


        }
    })

    tableData && tableData.sort((a,b)=> b["Identified DateTime"] - a["Identified DateTime"]);

    console.log("This is the table data for the all customers vector table,", tableData)
    const userTableHeadings = [
        { field: 'id', headerName: "ID", hide: true, flex: .5, type: "number" },
        { field: 'customerName', headerName: "Customer", hide: false, flex: 1, type: "string" },
        { field: 'name', headerName: "Threat Type", hide: false, flex: 1, type: "string",
            renderCell: (params)=>
                renderCellExpand(params,
                    (<span>
                            {params.value}
                        </span>
                    ))},
        { field: 'lastAttackDate', headerName: "Last Attack" , hide: false, width: 120, type: "date" },
        { field: 'numOfAttacks', renderHeader: (params) =>
                <div style={{lineHeight: "normal"}}>
                        <span>
                            # of <br/>
                            Attacks
                        </span>
                </div>,
            headerName: "# of Attacks", hide: false, width: 75, type: "string" },
        { field: 'targetDetailsStatus', renderHeader: (params) =>
                <div style={{lineHeight: "normal"}}>
                    <span >Active <br/> Target </span>
                </div>,
            headerName: "Active", hide: false, width: 90, type: "string",
            renderCell: (params)=>{
                return <Chip
                    label={`${params.value}`}
                    size={"small"}
                    color={params.value === true ? "secondary" : "default"}
                />
            } },
        { field: 'likelyToCauseBreach', renderHeader: (params) =>
                <div style={{lineHeight: "normal"}}>
                    <span>Breach <br/> Likely </span>
                </div>,
            headerName: "Breach Likely", hide: false, width: 90, type: "string",
            renderCell: (params)=>{
                return <Chip
                    label={`${params.value}`}
                    size={"small"}
                    color={params.value === true ? "secondary" : "default"}
                />
            }},
        { field: 'Identified DateTime', headerName: "Found ", hide: false, width: 120, type: "date" },
        { field: 'statusId', headerName: "Status Id", hide: true, flex: .5, type: "number" },
        { field: 'statusName',renderHeader: (params) =>
                <div style={{lineHeight: "normal"}}>
                    <span>Vector <br/> Status </span>
                </div>,
            headerName: "Vector Status", hide: false, width: 100, type: "string" },
        { field: 'targetDetailsIp', headerName: "IP Address", hide: false, flex: .5, type: "string", sortable: true,
            renderCell: (params)=>
                renderCellExpand(params, (<Tooltip title={``}>
                          <small>
                              <code>
                                {params.value}
                              </code>
                          </small>
                    </Tooltip>

                )),
            sortComparator: (v1, v2, param1, param2) => {
                try{
                    // console.log("IP column sort params", param1, param2);
                    return bbSortIpCompare(param1.value, param2.value);
                } catch(e) {
                    console.warn(e);
                    return false;
                }
            }},
        { field: 'domain', headerName: "Domain", hide: false, flex: 1, type: "string",
            renderCell: (params)=>{
                        return <small><code>
                            {params.value}
                        </code></small>
            }},
    ]

    const topRightElement =  <Tooltip title={"Attack Vectors across all customers."}>
        <InfoSharpIcon style={{fontSize: "large"}} className={``}/>
    </Tooltip>;

    useEffect(()=>{
        if (!customers && !loadingCustomers){
            dispatch(fetchCustomers());
        }
        if(customers){
            customersArr.forEach((customer)=>{
                const vectorsScoped = customer ? customer.vectors ? customer.vectors : null : null;
                if(customer && vectorsScoped === null && !loadingVectors){
                    dispatch(fetchVectorsAction({
                        customerId: customer.CustomerId
                    }))
                }
            })
        }
    }, [customers, loadingCustomers, loadingVectors, vectors, customersArr, dispatch])

    return(
        <div>
            {(customers
                && vectors
                && !loadingVectorsError
                && !loadingCustomers) ?
                (
                    <BBDataTable
                        columns={userTableHeadings}
                        rows={tableData}
                        title={"Vectors For All Customers"}
                        topRightElement={topRightElement}
                        progressValue={(numVectors / customersArr.length)* 100}
                        bufferValue={(numVectors + 1)/ customersArr.length * 100}
                        loading={false}
                        defaultPageSize={10}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        defaultSortModel = {[

                            {
                                field: 'Identified DateTime',
                                sort: 'asc',
                            },

                        ]}
                    >
                    </BBDataTable>
                )
                :
            (<BBDataTable
                        columns={userTableHeadings}
                        rows={[]}
                        title={"Vectors For All Customers"}
                        loading={true}
                        progressValue={0}
                        bufferValue={0}
                    />)
            }
        </div>
    )
}

export default TableAllCustomersVectors;